// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1143":"5dd7b8e05e56dd71","3422":"0bdfd4099f6a4313","4826":"b89fc20bcccb356a","5194":"7e9ae2d13bef3e79","7193":"c2e02cbcae6293ac","8015":"ca59b334aa6d8e3b"}[chunkId] + ".css";
};